import { Card, Space, Typography } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const { Title, Text } = Typography

const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: ${CantileverTheme.colors.blue['400']};
`

interface StepCardProps {
  stepNumber: number
  title: string
  description: string
  children: React.ReactNode
}

export const StepCard: FC<StepCardProps> = ({
  stepNumber,
  title,
  description,
  children,
}) => (
  <Card
    size='small'
    title={
      <Space size='middle'>
        <StepNumber>{stepNumber}</StepNumber>
        <Title level={5} style={{ margin: 0 }}>
          {title}
        </Title>
      </Space>
    }
    styles={{
      header: {
        padding: '16px 24px',
      },
    }}>
    <Text type='secondary' style={{ display: 'block', marginBottom: '1rem' }}>
      {description}
    </Text>
    {children}
  </Card>
)
